module.exports = __webpack_public_path__ + "img/Bengaluru Mobility Cover.73d65458.png";